function languageSwitcher() {
    const switchers = document.querySelectorAll('.wovn-languages-wrapper');
    switchers.forEach(switcher => {
        const languageItems = switcher.querySelectorAll('.wovn-switch');
        languageItems.forEach(item => {
            item.addEventListener('click', () => {
                setTimeout(() => {
                    switcher.classList.remove('active');
                }, 500);
            });
        });
    });
}

export function initLanguageSwitcher() {
    languageSwitcher();
}
